import { render } from "./UpdateContentCategoryPage.vue?vue&type=template&id=be8d66e0&ts=true"
import script from "./UpdateContentCategoryPage.vue?vue&type=script&lang=ts"
export * from "./UpdateContentCategoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Contents/Categories/UpdateContentCategoryPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be8d66e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be8d66e0', __exports__)) {
    api.reload('be8d66e0', __exports__)
  }
  
  module.hot.accept("./UpdateContentCategoryPage.vue?vue&type=template&id=be8d66e0&ts=true", () => {
    api.rerender('be8d66e0', render)
  })

}


export default __exports__